import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_oss_tags_selector = _resolveComponent("oss-tags-selector")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_AccountingTable = _resolveComponent("AccountingTable")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_OperatingAccountFromPartition = _resolveComponent("OperatingAccountFromPartition")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_AccountingBooklet = _resolveComponent("AccountingBooklet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized && _ctx.startMonthlyDates.length && _ctx.endMonthlyDates.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_row, {
              class: "pb-1",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_primary, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accountingBookletDialog = true)),
                      block: ""
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("Télécharger")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "pl-2 d-flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.firstPeriodStart,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstPeriodStart) = $event)),
                      items: _ctx.startMonthlyDates,
                      label: "Date de début",
                      elevation: "0",
                      "hide-details": "",
                      disabled: 
                            _ctx.notOnly6And7 ||
                            (!!_ctx.selectedAccountingClosing && !!_ctx.selectedAccountingClosing.id)
                        ,
                      "data-cy": "DashboardAccounting-dateDebut",
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "disabled"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.firstPeriodEnd,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstPeriodEnd) = $event)),
                      items: _ctx.endMonthlyDates,
                      label: "Date de fin",
                      elevation: "0",
                      "hide-details": "",
                      disabled: 
                            !_ctx.firstPeriodStart ||
                            (!!_ctx.selectedAccountingClosing && !!_ctx.selectedAccountingClosing.id)
                        ,
                      class: "pl-2",
                      "data-cy": "DashboardAccounting-dateFin",
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "1",
                      class: "d-flex justify-end align-center px-0 mx-0 flex-grow-0 flex-shrink-1",
                      style: {"max-width":"50px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "x-small",
                          variant: "text",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilter())),
                          class: "btn-filter",
                          "data-cy": "DashboardAccounting-delete"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { medium: "" }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode("$delete")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: _ctx.step === 'OperatingAccountFromPartition' ? 2 : 1,
                  class: "d-flex justify-center pl-1 flex-grow-1 flex-shrink-0",
                  style: _normalizeStyle(_ctx.$vuetify.display.mobile ? '' : 'min-width: 130px;')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.comparisonType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.comparisonType) = $event)),
                      items: _ctx.comparisonTypes,
                      label: "Afficher N-1",
                      elevation: "0",
                      "hide-details": "",
                      disabled: _ctx.disableDisplayNMoinsUn,
                      "data-cy": "DashboardAccounting-n1",
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }, 8, ["cols", "style"]),
                (_ctx.step !== 'OperatingAccountFromPartition')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "1",
                      class: "d-flex justify-center align-center flex-grow-1 flex-shrink-0",
                      style: _normalizeStyle(_ctx.$vuetify.display.mobile ? '' : 'min-width: 105px;')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.displayMonthlyData,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.displayMonthlyData) = $event)),
                          label: "Mensuel",
                          "hide-details": "",
                          density: "compact",
                          disabled: _ctx.disableDisplayMonthlyData
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true),
                (_ctx.budgets.length && _ctx.step !== 'OperatingAccountFromPartition')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          outlined: "",
                          items: _ctx.budgets,
                          "item-text": "name",
                          "item-value": "id",
                          "model-value": _ctx.budgets[_ctx.selectedBudget].name,
                          "hide-details": true,
                          density: "compact",
                          "append-inner-icon": 'arrow_drop_down',
                          "onUpdate:modelValue": _ctx.updateSelectedBudget,
                          "item-title": (item) => item.name
                        }, null, 8, ["items", "model-value", "onUpdate:modelValue", "item-title"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
                        !_ctx.$vuetify.display.mobile &&
                        _ctx.step !== 'OperatingAccountFromPartition' &&
                        _ctx.step !== 'Bilan'
                    )
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 3,
                      cols: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_tags_selector, {
                          modelValue: _ctx.tags,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tags) = $event)),
                          items: _ctx.usedTags,
                          label: 'Filtrer par étiquettes',
                          class: "pl-2",
                          itemTitle: (item) => item.text
                        }, null, 8, ["modelValue", "items", "itemTitle"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step) = $event)),
              "fixed-tabs": "",
              style: {"border-radius":"16px","overflow":"hidden"}
            }, {
              default: _withCtx(() => [
                (_ctx.done(_ctx.OA_FlashSituation))
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      value: "Flash",
                      href: "#Flash",
                      "data-cy": "DashboardAccounting-flash"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createElementVNode("strong", null, "Flash", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isAccountingClientUser && _ctx.done(_ctx.OA_SIG))
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 1,
                      value: "SIG",
                      href: "#SIG",
                      "data-cy": "DashboardAccounting-sig"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createElementVNode("strong", null, "SIG", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isAccountingClientUser && _ctx.OA_BalanceSheet && _ctx.OA_BalanceSheet.length)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 2,
                      value: "Bilan",
                      href: "#Bilan",
                      "data-cy": "DashboardAccounting-bilan"
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("strong", null, "Bilan", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
                        !_ctx.isAccountingClientUser && _ctx.OA_IncomeStatement && _ctx.OA_IncomeStatement.length
                    )
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 3,
                      value: "1",
                      href: "#1",
                      "data-cy": "DashboardAccounting-compteResultat"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createElementVNode("strong", null, "Compte de résultat", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.partitionTags && _ctx.partitionTags.length)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 4,
                      value: "OperatingAccountFromPartition",
                      href: "#OperatingAccountFromPartition"
                    }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createElementVNode("strong", null, "Tableau analytique", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.custom_OA && _ctx.custom_OA.length)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 5,
                      value: "4",
                      href: "#4"
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createElementVNode("strong", null, "Tableau personnalisé", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "Flash" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-center pt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.OA_FlashSituation && _ctx.OA_FlashSituation.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  modelValue: _ctx.selectorOaFlashSituation,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectorOaFlashSituation) = $event)),
                                  items: _ctx.OA_FlashSituation,
                                  "item-value": "id",
                                  label: "Choisissez votre compte d'exploitation",
                                  "background-color": "white",
                                  "hide-details": "",
                                  class: "pb-1",
                                  width: "80vm;",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccountingTable, {
                      ref: "Flash",
                      operatingAccountId: _ctx.selectorOaFlashSituation,
                      myKey: 'Flash',
                      currentKey: _ctx.step,
                      options: _ctx.options[_ctx.step],
                      periods: _ctx.periods,
                      tags: _ctx.tagIds,
                      displayMonthlyData: _ctx.displayMonthlyData,
                      round: true,
                      withSelector: _ctx.OA_FlashSituation && _ctx.OA_FlashSituation.length > 1
                    }, null, 8, ["operatingAccountId", "currentKey", "options", "periods", "tags", "displayMonthlyData", "withSelector"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "SIG" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-center pt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.OA_SIG && _ctx.OA_SIG.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  modelValue: _ctx.selectorOaSIG,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectorOaSIG) = $event)),
                                  items: _ctx.OA_SIG,
                                  "item-value": "id",
                                  label: "Choisissez votre compte d'exploitation",
                                  "background-color": "white",
                                  "hide-details": "",
                                  width: "80vm;",
                                  class: "pb-1",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccountingTable, {
                      ref: "SIG",
                      myKey: 'SIG',
                      currentKey: _ctx.step,
                      options: _ctx.options[_ctx.step],
                      operatingAccountId: _ctx.selectorOaSIG,
                      periods: _ctx.periods,
                      tags: _ctx.tagIds,
                      displayMonthlyData: _ctx.displayMonthlyData,
                      withSelector: _ctx.OA_SIG && _ctx.OA_SIG.length > 1,
                      round: true
                    }, null, 8, ["currentKey", "options", "operatingAccountId", "periods", "tags", "displayMonthlyData", "withSelector"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-center pt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.OA_IncomeStatement && _ctx.OA_IncomeStatement.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  modelValue: _ctx.selectorOaIncomeStatement,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectorOaIncomeStatement) = $event)),
                                  items: _ctx.OA_IncomeStatement,
                                  "item-value": "id",
                                  label: "Choisissez votre compte d'exploitation",
                                  "background-color": "white",
                                  "hide-details": "",
                                  width: "80vm;",
                                  class: "pb-1",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccountingTable, {
                      options: _ctx.options[_ctx.step],
                      operatingAccountId: _ctx.selectorOaIncomeStatement,
                      myKey: '1',
                      currentKey: _ctx.step,
                      ref: "1",
                      periods: _ctx.periods,
                      tags: _ctx.tagIds,
                      displayMonthlyData: _ctx.displayMonthlyData,
                      withSelector: _ctx.OA_IncomeStatement && _ctx.OA_IncomeStatement.length > 1,
                      round: true
                    }, null, 8, ["options", "operatingAccountId", "currentKey", "periods", "tags", "displayMonthlyData", "withSelector"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "Bilan" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex justify-center pt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.OA_BalanceSheet && _ctx.OA_BalanceSheet.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  modelValue: _ctx.selectorOaBalanceSheet,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectorOaBalanceSheet) = $event)),
                                  items: _ctx.OA_BalanceSheet,
                                  "item-value": "id",
                                  label: "Choisissez votre compte d'exploitation",
                                  "background-color": "white",
                                  "hide-details": "",
                                  class: "pb-1",
                                  width: "80vm;",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccountingTable, {
                      options: _ctx.options[_ctx.step],
                      operatingAccountId: _ctx.selectorOaBalanceSheet,
                      myKey: 'Bilan',
                      currentKey: _ctx.step,
                      ref: "Bilan",
                      periods: _ctx.periods,
                      tags: _ctx.tagIds,
                      displayMonthlyData: _ctx.displayMonthlyData,
                      withSelector: _ctx.OA_BalanceSheet && _ctx.OA_BalanceSheet.length > 1,
                      round: true
                    }, null, 8, ["options", "operatingAccountId", "currentKey", "periods", "tags", "displayMonthlyData", "withSelector"])
                  ]),
                  _: 1
                }),
                (_ctx.partitionTags && _ctx.partitionTags.length)
                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                      key: 0,
                      value: "OperatingAccountFromPartition"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OperatingAccountFromPartition, {
                          ref: "OperatingAccountFromPartition",
                          periods: _ctx.periods,
                          partitionTags: _ctx.partitionTags,
                          operatingAccountJsons: _ctx.operatingAccountJsons,
                          round: true,
                          onEmittedDataFromOAFP: _ctx.handleDataFromOAFP
                        }, null, 8, ["periods", "partitionTags", "operatingAccountJsons", "onEmittedDataFromOAFP"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.custom_OA && _ctx.custom_OA.length)
                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                      key: 1,
                      value: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "d-flex justify-center pt-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "8",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.custom_OA.length > 1)
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 0,
                                      modelValue: _ctx.selectorCustomOA,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectorCustomOA) = $event)),
                                      items: _ctx.custom_OA,
                                      "item-value": "id",
                                      label: "Choisissez votre compte d'exploitation",
                                      "background-color": "white",
                                      "hide-details": "",
                                      class: "pb-1",
                                      width: "80vm;",
                                      density: "compact",
                                      "item-title": (item) => item.name
                                    }, null, 8, ["modelValue", "items", "item-title"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.selectorCustomOA)
                          ? (_openBlock(), _createBlock(_component_AccountingTable, {
                              key: 0,
                              options: _ctx.options[_ctx.step],
                              operatingAccountId: _ctx.selectorCustomOA,
                              myKey: '4',
                              currentKey: _ctx.step,
                              ref: "4",
                              periods: _ctx.periods,
                              tags: _ctx.tagIds,
                              displayMonthlyData: _ctx.displayMonthlyData,
                              withSelector: _ctx.custom_OA.length > 1
                            }, null, 8, ["options", "operatingAccountId", "currentKey", "periods", "tags", "displayMonthlyData", "withSelector"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.accountingBookletDialog)
              ? (_openBlock(), _createBlock(_component_AccountingBooklet, {
                  key: 0,
                  modelValue: _ctx.accountingBookletDialog,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountingBookletDialog) = $event)),
                  tabFather: _ctx.options[_ctx.step],
                  startDateFather: _ctx.firstPeriodStart,
                  endDateFather: _ctx.firstPeriodEnd,
                  optionsFather: _ctx.optionsExport,
                  tagsFather: _ctx.tags,
                  usedTagsFather: _ctx.usedTags,
                  partitionTags: _ctx.partitionTags,
                  periods: _ctx.periods,
                  dataFromOAFP: _ctx.dataFromOAFP
                }, null, 8, ["modelValue", "tabFather", "startDateFather", "endDateFather", "optionsFather", "tagsFather", "usedTagsFather", "partitionTags", "periods", "dataFromOAFP"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}